module.exports = __webpack_public_path__ + "static/img/2.def8ab87.jpg";